import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { Provider } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';

import ControlPanel from '../ControlPanel/ControlPanel';
import { TemplateContext } from '..';
import { getTemplateFriendlyType } from 'templates';
import { BASE_URL } from 'consts';
import Preview from '../Preview/Preview';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Media from '../../Template/components/Media';

import '../styles/TemplateEditor.css';

import FormControl from '@material-ui/core/FormControl';
import { backLink } from 'utils';

const styles = theme => ({
  content: {
    flexGrow: 1,
    minWidth: 1024,
  },
  bottomContainer: {
    display: 'flex',
    margin: '0 0 5px 0',
    justifyContent: 'flex-end',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    margin: 0,
  },
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginLeft: '20px',
  },
  sup: {
    fontSize: '50%',
    top: '-1em',
  },
});

const fillDialogForm = (props, self) => {
  if (props.standOption) {
    self.setState({
      pageMessage: props.standOption.pageMessage ? props.standOption.pageMessage : '',
      image: props.standOption.image ? props.standOption.image : '',
      imageUrl: props.standOption.imageUrl ? props.standOption.imageUrl : '',
      previewD: true,
    });
  } else {
    self.setState({
      previewD: true,
    });
  }
};

class TemplateEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: false,
      previewD: false,
      redirect: null,
      pageMessage: '',
      image: '',
      imageUrl: '',
      oldForm: null,
    };

    this.updateImageToSend = this.updateImageToSend.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps &&
      prevState &&
      nextProps.standOption &&
      (!prevState.oldForm ||
        (prevState.oldForm && nextProps.standOption.imageUrl === prevState.imageUrl) ||
        nextProps.standOption.image === prevState.image ||
        nextProps.standOption.pageMessage !== prevState.pageMessage)
    ) {
      return {
        oldForm: nextProps.standOption,
      };
    }
    return null;
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  updateImageToSend = (image, imageUrl) => {
    this.setState({ image: image, imageUrl: imageUrl });
  };

  cleanForm = () => {
    this.setState({
      previewD: false,
      pageMessage: '',
      image: '',
      imageUrl: '',
    });
  };

  onPostMessage = event => {
    if (event && event.data && event.data.action === 'redirect') {
      this.setState({ redirect: event.data.url });
    }
  };

  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('message', this.onPostMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', this.onPostMessage, false);
    }
  }

  render() {
    const {
      classes,
      store,
      auth,
      module,
      type,
      editingId,
      hasDownloadPage,
      updateStandalone,
    } = this.props;

    if (
      store === null ||
      store === undefined ||
      module === null ||
      module === undefined ||
      auth === null ||
      auth === undefined ||
      auth.user === null ||
      auth.user === undefined
    ) {
      return <div />;
    }
    const Control = module.ControlPanel;
    const Storyboard = module.Storyboard;
    const title = getTemplateFriendlyType(type);
    const previewUrl = `${BASE_URL}/template/${type}/preview/${editingId}/${auth.user._id}`;

    const mediaContainer = {
      backgroundImage: `url("${this.state.imageUrl}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };

    return (
      <div className={classes.content}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6" gutterBottom>
              Lean In Moment<sup className={classes.sup}>TM</sup>
              {title ? ` Template Editor (${title})` : ` Template Editor`}
            </Typography>
            <div className={classes.bottomContainer}>
              <Button
                variant="text"
                color="default"
                className={classes.button}
                component={Link}
                to={backLink(this.props, 2)}
              >
                back
              </Button>
            </div>

            <TemplateContext.Provider value={{ auth, type }}>
              <Provider store={store}>
                <div>
                  <ControlPanel
                    showPreview={() => this.setState({ preview: true, redirect: false })}
                    type={type}
                    fillDialogForm={() => {
                      fillDialogForm(this.props, this);
                    }}
                    hasDownloadPage={hasDownloadPage}
                    updateStand={() =>
                      updateStandalone(
                        {
                          hasDownloadPage: !hasDownloadPage,
                        },
                        editingId
                      )
                    }
                  >
                    {Control ? <Control /> : null}
                  </ControlPanel>
                  {Storyboard ? <Storyboard template={type} /> : null}
                </div>
              </Provider>
            </TemplateContext.Provider>
          </Grid>
        </Grid>

        <Preview
          open={this.state.preview}
          onClose={() => this.setState({ preview: false })}
          url={this.state.redirect ? this.state.redirect : previewUrl}
        />
        <Dialog
          open={this.state.previewD}
          onClose={() => {
            this.setState({ previewD: false });
          }}
          fullWidth={true}
          maxWidth="sm"
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
        >
          <DialogTitle id="scroll-dialog-title">Edit Download Page</DialogTitle>
          <DialogContent dividers>
            <div
              style={{
                float: 'left',
                display: 'flex',
                flexWrap: 'wrap',
                flexGrow: 1,
                flexDirection: 'column',
                width: '50%',
              }}
            >
              <TextField
                style={{ marginBottom: '20px' }}
                id="outlined-multiline-static"
                multiline
                rows={4}
                label="Page message"
                name="name"
                placeholder="Enter page message"
                value={this.state.pageMessage}
                onChange={event => {
                  this.handleChange('pageMessage', event.target.value);
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div
              style={{
                float: 'right',
                flexGrow: 1,
                flexWrap: 'wrap',
                display: 'flex',
                flexDirection: 'column',
                width: '50%',
              }}
            >
              <Typography variant="subtitle2" gutterBottom align="center">
                Page image
              </Typography>

              <div
                className={
                  this.state.imageUrl !== ''
                    ? (mediaContainer, ' icon-container media-container')
                    : 'icon-container media-container'
                }
                style={{
                  width: 200,
                  height: 200,
                  boxSizing: 'border-box',
                  margin: '0 auto',
                }}
              >
                <Media
                  size={200}
                  auth={auth}
                  mediaType="image"
                  mediaFile={this.state.image}
                  mediaUrl={this.state.imageUrl}
                  onChange={this.updateImageToSend}
                  onFetch={this.updateImageToSend}
                  standalone={true}
                  updateImageToSend={this.updateImageToSend}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.cleanForm();
              }}
              color="primary"
            >
              Cancel
            </Button>
            <FormControl className={classes.textField} key="pointsPerPlay">
              <Button
                color="primary"
                onClick={() => {
                  const standaloneData = {
                    pageMessage: this.state.pageMessage,
                    image: this.state.image,
                    imageUrl: this.state.imageUrl,
                  };

                  updateStandalone(standaloneData, editingId, true);
                  this.cleanForm();
                }}
                disabled={'selectedElement' === 'undefined'}
              >
                Save
              </Button>
            </FormControl>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(TemplateEditor);
